import React from 'react';

import Responsive from './Responsive';

export default function Image({ url, ratio, ...rest }) {
  return (
    <Responsive ratio={ratio}>
      <img
        src={url}
        css={`
          width: 100%;
        `}
        {...rest}
      />
    </Responsive>
  );
}
